import { render } from "./FriendIcon.vue?vue&type=template&id=6ab63845&scoped=true"
const script = {}

import "./FriendIcon.vue?vue&type=style&index=0&id=6ab63845&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab63845"]])

export default __exports__